export function concatenateSets<T>(...iterables: any[]) {
  const set = new Set<T>();
  for (const iterable of iterables) {
    for (const item of iterable) {
      set.add(item);
    }
  }

  return set;
}


type Retorno<T> = {[key: string]: T};

export function convertArrayToObject<T>(array: T[], key: keyof T): Retorno<T> {
  const initialValue = {};

  const objeto = array.reduce((obj, item) => {
    const id: any = item[key];
    return {
      ...obj,
      [id]: item,
    };
  }, initialValue);

  return objeto as any;
};